export default __webpack_public_path__ + "static/media/group2.5b53f21e.jpg";